import React, { useState, useEffect, useContext } from "react";
import { FiArrowRight } from "react-icons/fi";
import AnaQuestion from "../../../components/AnalistQuestion";
import ProcessPropInfo from "../../../components/ProcessPropInfo";
import { list_questions } from "../../../services/questions";
import { Container, Content } from "./styles";
import { Link } from "react-router-dom";
import SessionContext from "../../../contexts/sessionContext";
import QuestionContext from "../../../contexts/QuestionContext";
import { notify } from "../../../components/Toast";

interface ListProps {
	title: string;
	id: number;
	answers: any;
}

function StepTwo() {
	const [list, setList] = useState<any[]>([]);

	const { user } = useContext(SessionContext);
	// Ver comentarios no contexto para entender
	const { values, setNecessaryDocuments, necessaryDocuments, documents } =
		useContext(QuestionContext);

	const [documentsIds, setDocumentsIds] = useState<number[]>([]);
	const [canPass, setCanPass] = useState(false);
	const [error, setError] = useState<{message: string, errorCode: string}>();
	const [docs, setDocs] = useState([]);

	//take the values from Context
	useEffect(() => {
		(async () => {
			try {
				const formatedDocs = documents?.map((doc: any) => ({
					id: doc.id,
					name: doc.name,
					documentTag: doc.documentTag?.name
				}));

				setDocs(formatedDocs);
			} catch (error) {
				return error;
			}
		})();
	}, []);

	function checkLengthQuestion(questionsResponded: number) {
		const docsNecessary = necessaryDocuments.filter((tag: any) => {
			const docsByTag = documents.map((doc: any) => doc.documentTagId);
			const exists = docsByTag.includes(tag);
			return !exists;
		});


		//Não tem documento faltando e respondeu todas as perguntas
		if (docsNecessary?.length === 0 && questionsResponded === 6) {
			if (error){
				setError(undefined);
			}
			return setCanPass(true);
		}

		setCanPass(false);

		if (docsNecessary?.length > 0 && questionsResponded === 0) {
			setError(
				{
					message: "Por favor, responda todas as perguntas e verifique os documentos necessários",
					errorCode: 'invalid_questions_and_documents'
				})
			return setCanPass(false);
		}

		if (docsNecessary?.length > 0 && questionsResponded === 6) {
			setError(
				{
					message: "Há documentos necessários que não foram identificados no processo",
					errorCode: "invalid_documents"
				})
			return setCanPass(false);
		}

		if (docsNecessary?.length === 0 && questionsResponded !== 6) {
			setError(
				{
					message: "Por favor, responda todas as perguntas para a próxima etapa",
					errorCode: "invalid_questions"
				})
			return setCanPass(false);
		}
	}

	useEffect(() => {
		const questionsResponded = Object.values(values) || [];
		checkLengthQuestion(questionsResponded.length);
	}, [necessaryDocuments, documentsIds]);

	useEffect(
		() => setDocumentsIds(documents?.map((doc: any) => doc.documentTagId)),
		[documents],
	);

	useEffect(() => {
		(async () => {
			const list = await list_questions(0);

			setList(list.data);
		})();
	}, []);

	const handleSelectSubCat = (tags: number[]) => {
		const newNecessaryDocs = new Set([...necessaryDocuments, ...tags]);

		setNecessaryDocuments([...newNecessaryDocs]);
	};

	return (
		<Container>
			<div className='header'>
				<p id='func'>Analista</p>
				<p id='name'>{user.name}</p>
			</div>
			<Content>
				<div className='content-wrapper' id='left'>
					<div className='content-header'>
						<p className='header-text'>Seleção de arquivos</p>
						<p id='content-instruction'>
							Preencha as perguntas para completar o checklist
						</p>
					</div>
					<div className='quests-wrapper'>
						{list
							? list.map((item: ListProps) => {
									return (
										<AnaQuestion
											title={item.title}
											key={item.id}
											id={item.id}
											answers={item.answers}
											handleSelectSubCat={
												handleSelectSubCat
											}
										/>
									);
							  })
							: null}
					</div>

					{!canPass ? (
						<div className='next-page btn-error'>
							<button
							onClick ={() =>
								notify(
									{message: error?.message as string,
									type: 'error',
									theme: 'colored',
									options:
										{
											className: "",
											toastId: error?.errorCode

										}
									})}
							title='Pode remover um documento necessário para continuar'
							>
								Próxima Etapa <FiArrowRight />
							</button>
						</div>
					) : (
						<div className='next-page'>
							<Link to={`/step-three`}>
								<button>
									Próxima Etapa <FiArrowRight />
								</button>
							</Link>
						</div>
					)}
				</div>

				<ProcessPropInfo />
			</Content>
		</Container>
	);
}

export default StepTwo;
